import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import { Button } from '@cuemath/web-comps';

export const StateContainer = styled(FlexView)`
  width: 100%;
  height: calc(100vh - 80px);
`;

export const ActionRow = styled(FlexView)`
  gap: 12px;
`;

export const SaveButton = styled(Button)`
  border-radius: 0;
`;
